import * as React from "react";
import PropTypes from "prop-types";
import { Label, DefaultButton, SearchBox, MessageBar } from "@fluentui/react";
import Header from "./Header";
import Search from './Search';
import HeroList from "./HeroList";
import Progress from "./Progress";
import PeoplePicker from "./PeoplePicker";

/* global require */

export default class App extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      listItems: [],
    };
  }

  componentDidMount() {
    this.setState({
      listItems: [
        {
          icon: "Ribbon",
          primaryText: "Achieve more with Office integration",
        },
        {
          icon: "Unlock",
          primaryText: "Unlock features and functionality",
        },
        {
          icon: "Design",
          primaryText: "Create and visualize like a pro",
        },
      ],
      
    });
      
  }

  click = async () => {
    /**
     * Insert your Outlook code here
     */
  };
  
  render() {
    const { title, isOfficeInitialized } = this.props;
   
    if (!isOfficeInitialized) {
      return (
        <Progress
          title={title}
          logo={require("./../../../assets/logo.png")}
          message="Please sideload your addin to see app body."
        />
      );
    }
    
    return (
      <div className="ms-welcome" style={{textAlign:"center"}}>
        <Header logo={require("./../../../assets/logo.png")} title={this.props.title} message="Welcome" />
        <div>
          <Label>This link to AdvisorConX will allow you to save emails directly into your client files</Label>
        </div>
        <div className="tc ma0 pa4 min-vh-100">
          <PeoplePicker />           
        </div>
      </div>
    );
  }
}

App.propTypes = {
  title: PropTypes.string,
  isOfficeInitialized: PropTypes.bool,
};
